import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BadgeCheck, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/lib/i18n";

export default function PaymentPage({ cancelled }) {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [state, setState] = useState(cancelled ? "cancelled" : "checking");
  const { user, setUser } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();

  useEffect(() => {
    if (cancelled || !sid) { if (!sid) setState("cancelled"); return; }
    let n = 0, stop = false;
    const poll = async () => {
      try {
        const s = await api.paymentStatus(sid);
        if (s.payment_status === "paid") { setState("paid"); try { setUser((await api.me()) || false); } catch { /* guest */ } return; }
        if (["expired", "failed"].includes(s.payment_status)) { setState("failed"); return; }
      } catch { /* retry */ }
      if (!stop && ++n < 15) setTimeout(poll, 2000); else if (!stop) setState("slow");
    };
    poll();
    return () => { stop = true; };
  }, [sid, cancelled, setUser]);

  return (
    <div className="screen" data-testid="payment-screen">
      <div className="screen-body payment-body">
        {state === "checking" && <div className="pay-state" data-testid="payment-checking"><Loader2 size={36} className="spin" />{t("Confirming your payment…")}</div>}
        {state === "paid" && <div className="pay-state" data-testid="payment-success"><BadgeCheck size={40} className="donate-heart" />
          <div className="header-title">{t("Thank you!")}</div>
          <div className="card-sub">{t("Your donation keeps Fuel Hauler Pro free for every driver.")}</div>
          <div className="card-sub" data-testid="payment-thanks-email">{t("A thank-you email is on its way.")}</div></div>}
        {state === "failed" && <div className="pay-state" data-testid="payment-failed"><XCircle size={36} />{t("We couldn't confirm the payment. No charge was made if checkout didn't finish.")}</div>}
        {state === "slow" && <div className="pay-state" data-testid="payment-slow"><Loader2 size={36} />{t("Your donation is still processing. It goes through by itself once it clears.")}</div>}
        {state === "cancelled" && <div className="pay-state" data-testid="payment-cancelled"><XCircle size={36} />{t("Checkout cancelled. No charge was made.")}</div>}
        {user === false
          ? <button type="button" className="primary-btn" data-testid="payment-create-account" onClick={() => nav("/login?mode=signup", { replace: true })}>{t("Create my account")}</button>
          : <button type="button" className="primary-btn" data-testid="payment-back" onClick={() => nav("/", { replace: true })}>{t("Back to the app")}</button>}
      </div>
    </div>
  );
}
